import $ from 'jquery'



export function backgroundInit() {

    var mul = 1.01;

    var h = window.innerHeight
    var y = window.scrollY;
    var d = document.documentElement.offsetHeight;

    var height = (d - h);
    var position = y;
    var percentage = 100;

    var mulHeight = (height * mul);
    var mulTop = (height - mulHeight) * percentage / 100;


    var bgAction = false;

    $('.c-pub-page-background__wrapper').css('height', (100 * mul) + '%');
    // $('.c-pub-page-background__wrapper').css({ 'margin-top': -(d) + 'px' });



    $(window).on('pub:scrolling', function () {

        h = window.innerHeight
        y = window.scrollY;
        d = document.documentElement.offsetHeight;

        height = (d - h);
        position = y;
        percentage = 100 / height * position;

        mulHeight = (height * mul);
        mulTop = (height - mulHeight - (h / 2)) * percentage / 100;

        if (!bgAction) {

            $('.c-pub-page-background__wrapper').css({ 'transform': 'translateY(' + (mulTop) + 'px)' });

            bgAction = true;
            setTimeout(function () {
                //console.log(bgAction);

                bgAction = false;


            },500);
        }


    })


}